import moment from "moment";


class TimeUtils {
    public static formatTimestamp(timestamp: any, format: string): string {
        if (timestamp instanceof Date) {
            timestamp = timestamp.getTime();
        }
        if (typeof(timestamp)=='string') {
            timestamp = Number(timestamp);
        }
        return moment(timestamp).format(format);
    }

    public static durationToText(value): string {
        if(value==null || value <0) {
            return 'N/A'
        } else if(value < this.minutesToMillis(1)) {
            return `${Math.floor(value/1000).toFixed(0)} 秒`;
        } else if(value < this.hoursToMillis(1)) {
            return `${Math.floor(value/this.minutesToMillis(1)).toFixed(0)} 分`;
        } else if(value < this.daysToMillis(1)) {
            return `${Math.floor(value/this.hoursToMillis(1)).toFixed(0)} 小时 ${Math.floor((value % this.hoursToMillis(1)) / this.minutesToMillis(1)).toFixed(0)} 分`;
        } else {
            return `${Math.floor(value/this.daysToMillis(1)).toFixed(0)} 天 ${Math.floor((value % this.hoursToMillis(1)) / this.hoursToMillis(1)).toFixed(0)} 小时`;
        }
        return 'N/A';
    }

    public static durationToHoursText(value): string {
        if(value==null || value <0) {
            return 'N/A'
        } else if(value < this.minutesToMillis(1)) {
            return `${Math.floor(value/1000).toFixed(0)} 秒`;
        } else if(value < this.hoursToMillis(1)) {
            return `${Math.floor(value/this.minutesToMillis(1)).toFixed(0)} 分`;
        } else {
            return `${Math.floor(value/this.hoursToMillis(1)).toFixed(0)} 小时 ${Math.floor((value % this.hoursToMillis(1)) / this.minutesToMillis(1)).toFixed(0)} 分`;
        }
        return 'N/A';
    }

    
    public static formatLastTime = (timestamp: number | string)=> {
        timestamp = Number(timestamp);
        let timestampNow = new Date().getTime();
        let value = timestampNow - timestamp;

        if(value==null || value <0) {
            return 'N/A'
        } else if(value < TimeUtils.minutesToMillis(1)) {
            return `${(value/1000).toFixed(0)} 秒前`;
        } else if(value < TimeUtils.hoursToMillis(1)) {
            return `${(value/TimeUtils.minutesToMillis(1)).toFixed(0)} 分前`;
        } else if(value < TimeUtils.daysToMillis(1)) {
            return `${(value/TimeUtils.hoursToMillis(1)).toFixed(0)} 小时前`;
        } else {
            return `${(value/TimeUtils.daysToMillis(1)).toFixed(0)} 天前`;
        }
        return 'N/A';
    }


    public static daysToMillis(days: number): number {
        return days * 24 * 60 * 60 * 1000;
    }

    public static hoursToMillis(hours: number): number {
        return hours * 60 * 60 * 1000;
    }

    public static minutesToMillis(minutes: number): number {
        return minutes * 60 * 1000;
    }

    public static secondsToMillis(seconds: number): number {
        return seconds * 1000;
    }
}

export default TimeUtils;
